<i18n src="@/locales/models/export_invoice.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>

<template>
  <div class="panel">
    <div class="panel-header">
      <h3 class="panel-header-title">Datos de la factura</h3>
    </div>
    <div class="panel-body">
      <div class="space-y-8 divide-y divide-slate-200">
        <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
          <div class="sm:col-span-3">
            <dt class="label-data">
              {{ $t("model.export_invoice.container") }}
            </dt>
            <dd class="content-data">
              {{ export_invoice.container.container_code }}
              <yes-no-label
                :value="export_invoice.container.export_invoices_paid"
                yes="Pagado"
                no="No pagado"
              />
            </dd>
          </div>
          <div class="sm:col-span-3">
            <dt class="label-data">
              {{ $t("model.container.customer") }}
            </dt>
            <dd class="content-data">
              {{ export_invoice.container.customer.name }}
            </dd>
          </div>
          <div class="sm:col-span-3">
            <dt class="label-data">
              {{ $t("model.export_invoice.invoice_code") }}

            </dt>
            <dd class="content-data">
              {{ export_invoice.invoice_code }}
              <yes-no-label
                :value="export_invoice.paid"
                yes="Pagada"
                no="No pagada"
              />
            </dd>
          </div>
          <div class="sm:col-span-3">
            <dt class="label-data">
              {{ $t("model.export_invoice.invoice_date") }}
            </dt>
            <dd class="content-data">
              {{ dateFormatter(export_invoice.invoice_date) }}
            </dd>
          </div>
          <div class="sm:col-span-3">
            <dt class="label-data">
              {{ $t("model.export_invoice.amount") }}
            </dt>
            <dd class="content-data">
              {{
                currencyMoney(
                  export_invoice.amount,
                  export_invoice.currency.symbol
                )
              }}
            </dd>
          </div>
          <div class="sm:col-span-3">
            <dt class="label-data">
              {{ $t("model.export_invoice.amount_paid") }}
            </dt>
            <dd class="content-data">
              {{
                currencyMoney(
                  export_invoice.amount_paid,
                  export_invoice.currency.symbol
                )
              }}
            </dd>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AEFinancesContainerIncomesExportInvoiceInfo",
  props: {
    export_invoice: {
      required: true
    }
  }
};
</script>
